import { DefaultContextControlContainer } from 'shared/containers/DefaultContextControl/DefaultContextControlContainer'
import { NotificationListContainer } from './containers/NotificationListContainer'

export const NotificationHome = (): JSX.Element => {
    return (
        <>  
            <NotificationListContainer />
            <DefaultContextControlContainer />
        </>
    )
}